import * as React from "react"

const SvgMenuIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={20}
    viewBox="0 0 25 20"
    {...props}
  >
    <g fill="#515252">
      <path data-name="Rectangle 62" d="M0 0h25v2H0z" />
      <path data-name="Rectangle 64" d="M0 18h25v2H0z" />
      <path data-name="Rectangle 63" d="M0 9h20v2H0z" />
    </g>
  </svg>
)

export default SvgMenuIcon
